<template>
<v-container fluid>
  <v-form ref="form">
    
    <CheckBox
      :label="$t('Использовать Max бота')"
      :hint="$t('Заказы будут отправляться в Max')"
      :original_value="config.enabled"
      :disabled="disabled"
      v-model="local_config.enabled"
    />

    <TextField
      :loading="any_loading"
      :label="$t('Токен Max бота')"
      :hint="$t('Токен необходимо скопировать при создании бота или в личном кабинете BotFather')"
      :disabled="disabled || !local_config.enabled"
      :original_value="config.token_bot"
      v-model="local_config.token_bot"
    />

    <TextField
      :loading="any_loading"
      :label="$t('ID чата')"
      :hint="`${$t('ID чата в который необходимо отправлять уведомления из заказов в магазине')}`"
      :disabled="disabled || !local_config.enabled"
      :original_value="config.chat_id"
      v-model="local_config.chat_id"
    />

  </v-form>
</v-container>
</template>

<script>
import TextField from '../../../common/TextField.vue'
import CheckBox from '../../../common/CheckBox.vue'
import settings_group_mixin from '../../settings_group_mixin'

export default {
  mixins: [settings_group_mixin],
  props: {
    disabled: Boolean
  },

  computed: {
    any_loading() {
      return this.local_loading
    }
  },

  methods: {
    validate(){
      if (this.local_config.enabled) {
        if (!this.local_config.token_bot) {
          throw new Error(this.$t('Укажите токен Max бота'))
        }
        if (!this.local_config.chat_id) {
          throw new Error(this.$t('Укажите ID чата'))
        }
      }
    }
  },

  components: {
    TextField,
    CheckBox
  }
}
</script>